import { render, staticRenderFns } from "./AreaAssetCreate.vue?vue&type=template&id=4adb4b6c"
import script from "./AreaAssetCreate.vue?vue&type=script&lang=js"
export * from "./AreaAssetCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports